<template>
  <BasePage title="Groups">
    <div class="columns">
      <div class="column is-half-desktop is-offset-one-quarter-desktop">

        <LinkTab :tabs="tabs"/>

        <slot></slot>

      </div>
    </div>
  </BasePage>
</template>

<script>
import { mapGetters } from 'vuex'

import BasePage from './BasePage.vue'
import LinkTab from './LinkTabs'

export default {
  name: 'GroupBase',
  components: {
    BasePage,
    LinkTab,
  },
  computed: {
    ...mapGetters([
      'canCreateUsers',
      'groupCount',
    ]),
    tabs () {
      const createTab = {
        to: '/group-create',
        title: 'Create',
      }

      const baseTabs = [
        {
          to: '/groups',
          title: 'My Groups',
          count: this.groupCount,
        },
        {
          to: '/group-find',
          title: 'Find',
        },
      ]

      return this.canCreateGroups
        ? baseTabs.concat(createTab)
        : baseTabs
    },
  },
}
</script>



// WEBPACK FOOTER //
// GroupBase.vue?49a96c21